export const globalReactSelectTheme = (theme) => ({
    ...theme,
    borderRadius: "5px",
    colors: {
      ...theme.colors,
      primary: '#1b5162',
      primary25: '#f6f6f6',
      primary50: '#f6f6f6',
    },
  });